import React from 'react';
import {connect} from 'react-redux';
import {submit} from 'redux-form';

// const style = {
// padding: '10px 20px',
// width: 140,
// display: 'block',
// margin: '20px auto',
// fontSize: '16px',
// };

const RemoteSubmitButton = ({dispatch, disabled}) => {
    console.log(disabled);
    return (
        <button disabled={disabled}
                type="button"

                onClick={() => dispatch(submit('SimpleForm'))}

        >
            Enviar
        </button>
    );
}

export default connect()(RemoteSubmitButton);


// WEBPACK FOOTER //
// ./src/components/RemoteSubmitButton.js